module.exports = __webpack_public_path__ + "media/images/thankyou-0d25c341bbff8e14f10544ba2a234cfe.svg";